import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const FeaturesSection = styled(Box)(({ theme }) => ({
  backgroundColor: '#ffffff ',
  padding: '60px 86px',
  [theme.breakpoints.down('lg')]: {
    padding: '50px 40px',
  },
  [theme.breakpoints.down('md')]: {
    padding: '40px 24px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '30px 16px',
  },
}));

export const FeaturesContainer = styled(Box)(({ theme }) => ({
  maxWidth: '1400px',
  margin: '0 auto',
  padding: '80px 0 0',
  justifyContent: 'space-between',
  display: 'flex',
  columnGap: theme.spacing(8),
  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
    rowGap: theme.spacing(6),
    padding: '60px 0 0',
  },
  [theme.breakpoints.down('md')]: {
    padding: '40px 0 0',
    rowGap: theme.spacing(4),
  },
  [theme.breakpoints.down('sm')]: {
    padding: '30px 0 0',
    rowGap: theme.spacing(3),
  },
}));
export const FeatureSubtitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: 40,
  color: theme.palette.primary.main,
  [theme.breakpoints.down('lg')]: {
    fontSize: 36,
  },
  [theme.breakpoints.down('md')]: {
    fontSize: 32,
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 24,
    textAlign: 'center',
  },
}));
